import * as d3 from 'd3'

export default {
  methods: {
    
    call_Button(selection, d) {

      selection
      .attr('cursor', 'pointer')
      .on('mouseover', function() {
        d3.select(this).transition().duration(100).attr('opacity', 0.5)
      })
      .on('mouseout', function() {
        d3.select(this).transition().duration(200).attr('opacity', 1)
      })
      .on('click', () => {
        if(this.current==d.code) return

        d3.select(`#BTN_${this.current}`).attr('fill', '#bcbcbc')
        d3.select(`#BTN_${d.code}`).attr('fill', '#44A9DF')
        d3.select(`#LINE_${this.localId}`).transition().duration(200)
        .attr('x', d.lineX).attr('width', this.getNode(`#BTN_${d.code}`, 'width') + 4)

        this.current = d.code
        console.log(this.current)
        this.set_selectedItems() // -----> PDF.js
        this.refresh_Chart()
      }) 
    },

    
    call_Trends(selection, cDate) {
      if (this.trend.link != 'Y') return

      selection
      .attr('cursor', 'pointer')
      .on('mouseover', function() {
        d3.select(this).attr('opacity', 0.5).attr('font-weight', 600)
      })
      .on('mouseout', function() {
        d3.select(this).attr('opacity', 1).attr('font-weight', 'normal')
      })
      .on('click', () => { 
        let data = this.trendData.find(f=> f[this.ref.item] == this.current && f[this.ref.timeline] == cDate)
        if(data[this.ref.trend]==0) return
        this.call_Link(data, this.trendfilters)
      })
    },


    call_WeekPerformance(selection, week) {
      if (this.week.link != 'Y') return
      
      selection
      .attr('cursor', 'pointer')
      .on('mouseover', function() {
        d3.select(this).attr('opacity', 0.5).attr('font-weight', 600)
      })
      .on('mouseout', function() {
        d3.select(this).attr('opacity', 1).attr('font-weight', 'normal')
      })
      .on('click', () => { 
        let data = this.weekData.find(f=> f[this.ref.item]==this.current && f.WEEK == week)
        if(data[this.ref.week]==0) return
        this.call_Link(data, this.weekfilters[data.filter])
      })
    },


    call_Link(data, fString) {

      // set for filterString 
      let filterString_ = fString
      
      let dataSource = {}
      Object.keys(this.keys).forEach(d=>{
        dataSource = {...dataSource, [d]: data[this.keys[d]]}
      })
      console.log(dataSource, filterString_) // #####

      let request_ = this.getRequestColumnProps('request', dataSource, this.ColumnProps)
      if(!request_) return

      if(request_.iFilters.filterString) {
        request_.iFilters.filterString += filterString_ ? ` AND ${filterString_} ` : ''
      } else {
        request_.iFilters.filterString = filterString_||''
      }

      // combine filterString and inputFilter &&& emit request-action
      request_ = {...request_,
        filters : {
          ...this.FilterValues,
          ...request_.filters,
        },
        iFilters: { 
          filterString : request_.iFilters.filterString||'',
          inputFilter : request_.iFilters.inputFilter,},
      }
      this.$emit('request-action', request_)
    },
  }
}